import type { AppLocale } from "./index"
import { EXTENDED_VEHICLE_ACTIVITY } from "./extendedLocaleUi"
import { isSpecialLocale, SPECIAL_UI } from "./specialLocales"
import { PUBLIC_EXTRA_VEHICLE_ACTIVITY } from "./publicExtraBasicUi"
import { isPublicExtraLocale } from "./publicExtraSignals"
import { uzbekLatinToCyrillic } from "./uzbekCyrillic"
import { isExpansionLocale } from "./publicExpansionSignals"
import { EXPANSION_VEHICLE_ACTIVITY } from "./publicExpansionBasicUi"

const ONLINE: Partial<Record<AppLocale, string>> = {
  ru:"Онлайн", en:"Online", es:"En línea", "pt-BR":"Online", it:"Online", tr:"Çevrimiçi", uk:"Онлайн", kk:"Онлайн", uz:"Onlayn", id:"Online", ms:"Dalam talian", vi:"Trực tuyến", tl:"Online", hi:"ऑनलाइन", ar:"متصل", fa:"آنلاین", ur:"آن لائن",
  be:EXTENDED_VEHICLE_ACTIVITY.be.online, hy:EXTENDED_VEHICLE_ACTIVITY.hy.online, ka:EXTENDED_VEHICLE_ACTIVITY.ka.online, ky:EXTENDED_VEHICLE_ACTIVITY.ky.online, tg:EXTENDED_VEHICLE_ACTIVITY.tg.online,
}

const RECENT: Partial<Record<AppLocale, string>> = {
  ru:"Был недавно", en:"Seen recently", es:"Visto recientemente", "pt-BR":"Visto recentemente", it:"Visto di recente", tr:"Yakın zamanda görüldü", uk:"Був нещодавно", kk:"Жақында болды", uz:"Yaqinda ko‘rindi", id:"Baru terlihat", ms:"Dilihat baru-baru ini", vi:"Vừa hoạt động", tl:"Kamakailan lang", hi:"हाल ही में सक्रिय", ar:"نشط مؤخرًا", fa:"اخیراً فعال بوده", ur:"حال ہی میں فعال تھا",
  be:EXTENDED_VEHICLE_ACTIVITY.be.recent, hy:EXTENDED_VEHICLE_ACTIVITY.hy.recent, ka:EXTENDED_VEHICLE_ACTIVITY.ka.recent, ky:EXTENDED_VEHICLE_ACTIVITY.ky.recent, tg:EXTENDED_VEHICLE_ACTIVITY.tg.recent,
}

export function localizeVehicleActivity(locale: AppLocale, label?: string | null): string {
  if (!label) return ""
  const normalized = label.trim().toLocaleLowerCase("ru-RU")
  if (isExpansionLocale(locale)) {
    if (normalized === "онлайн" || normalized === "online") return EXPANSION_VEHICLE_ACTIVITY[locale].online
    if (normalized === "был недавно" || normalized === "была недавно" || normalized === "seen recently") return EXPANSION_VEHICLE_ACTIVITY[locale].recent
    return ""
  }
  if (isSpecialLocale(locale)) {
    if (normalized === "онлайн" || normalized === "online") return SPECIAL_UI[locale].activity.online
    if (normalized === "был недавно" || normalized === "была недавно" || normalized === "seen recently") return SPECIAL_UI[locale].activity.recent
    return ""
  }
  if (isPublicExtraLocale(locale)) {
    if (normalized === "онлайн" || normalized === "online") return PUBLIC_EXTRA_VEHICLE_ACTIVITY[locale].online
    if (normalized === "был недавно" || normalized === "была недавно" || normalized === "seen recently") return PUBLIC_EXTRA_VEHICLE_ACTIVITY[locale].recent
    return ""
  }
  if (normalized === "онлайн" || normalized === "online") {
    const value = ONLINE[locale] ?? ONLINE.ru!
    return locale === "uz" ? uzbekLatinToCyrillic(value) : value
  }
  if (normalized === "был недавно" || normalized === "была недавно" || normalized === "seen recently") {
    const value = RECENT[locale] ?? RECENT.ru!
    return locale === "uz" ? uzbekLatinToCyrillic(value) : value
  }
  return locale === "ru" ? label : ""
}
